import baseConfig from './baseConfig'
import {clientCsaveExtensions} from './csaveConfigs'
import type {DSConfig} from '../dsConfig'
// eslint-disable-next-line import/no-unresolved
import appComponentVersionsConfig from '@wix/dm-fragment-configs/configs/appComponentVersionsConfig.json'
// eslint-disable-next-line import/no-unresolved
import siteContextConfig from '@wix/dm-fragment-configs/configs/siteContextConfig.json'

const config = {
    ...baseConfig,
    runStylesGC: false,
    supportMobile: false,
    postUpdateOperation: false,
    runPreSaveOperationInQueue: true,
    loadsMiniSiteManager: true,
    documentDataFixer: 'responsiveDocument',
    isReadOnly: false,
    noUndo: false,
    disableCommonConfig: false,
    modulesList: [
        'branchesPublicAPI',
        'accessibilityPublicAPI',
        'dataModelPublicAPI',
        'featuresPublicAPI',
        'slotsPublicAPI',
        'statesPublicAPI',
        'triggersPublicAPI',
        'reactionsPublicAPI',
        'documentModePublicAPI',
        'remoteStructureMetaDataPublicApi',
        'renderPluginsPublicApi',
        'savePublicAPI',
        'componentPublicAPI',
        'innerElementsPublicAPI',
        'refComponentPublicAPI',
        'componentDetectorPublicAPI',
        'responsivePublicAPI',
        'breakpointsPublicAPI',
        'namedRangesPublicAPI',
        'responsiveStylesPublicAPI',
        'siteMetadataPublicAPI',
        'themeCssVariablesPublicAPI',
        'globalStylesPublicAPI',
        'globalComponentsPublicAPI',
        'forwardRefPublicAPI',
        'cssStylePublicAPI',
        'snapshotPublicAPI',
        'pagePublicAPI',
        'scrollAnchorsPublicAPI',
        'siteSegmentsPublicAPI',
        'componentsMetaDataPublicAPI',
        'appControllerDataPublicAPI',
        'connectionsPublicAPI',
        'platformPublicAPI',
        'routersPublicAPI',
        'autosavePublicAPI',
        'biPublicAPI',
        'environmentPublicAPI',
        'actionsAndBehaviorsPublicAPI',
        'structurePublicAPI',
        'debugPublicAPI',
        'atomicScopesPublicAPI',
        'menuPublicAPI',
        'smartBoxesPublicAPI',
        'sectionOrderPublicAPI',
        'fontsPublicAPI',
        'mediaPublicAPI',
        'tpaPublicAPI',
        'pagesGroupPublicAPI',
        'siteMembersPublicAPI',
        'wixCodePublicAPI',
        'cmsPublicAPI',
        'variantsPublicAPI',
        'accountPublicAPI',
        'transformationsPublicAPI',
        'transitionsPublicAPI',
        'errorsPublicAPI',
        'componentsLoaderPublicAPI',
        'appStudioWidgetsPublicAPI',
        'multilingualPublicAPI',
        'localesPublicAPI',
        'partnersPublicAPI',
        'variablesPublicAPI',
        'scopesPublicAPI',
        'patternsPublicAPI',
        'effectsPublicAPI',
        'deprecatedOldBadPerformancePublicAPI',
        'customCSSPublicAPI',
        'aiPublicAPI',
        'externalComponentsPublicAPI',
        'importExportPublicAPI',
        'builderComponentsPublicAPI',
        'historyAPI',
        'mobileAlgoPublicApi',
        'editorFeaturesPublicAPI',
        'observablesPublicAPI',
        'contextsPublicAPI',
        'bindingsPublicAPI',
        'runtimeBindingsPublicAPI'
    ],
    extensionsList: [
        ...baseConfig.extensionsList,
        'layoutSettings',
        'mobileAlgo',
        'undoRedo',
        'metadata',
        'save',
        'lifecycle',
        'layoutCircuitBreaker',
        'viewerRuntime',
        'contactFormMetaData',
        'appBuilder',
        'sectionOrder',
        'documentToViewer',
        'wixapps',
        'accountInfo',
        'commonConfig',
        'seo',
        ...clientCsaveExtensions,
        'componentsByType',
        'partners',
        'componentsRegistry',
        'aiContent',
        'proactiveAssistance',
        'eventHandler',
        'fileUpload',
        'responsiveFixers',
        'measurements',
        'editorFeatures',
        'namedRanges',
        'contexts',
        'bindings',
        'runtimeBindings'
    ],
    supportedFragments: {
        ...baseConfig.supportedFragments,
        // loaded via DocumentModels response, not on init
        AppComponentVersions: Object.assign(appComponentVersionsConfig.defaultConfigurations, {
            loadOnInit: false
        }),
        EditorFeatures: {
            loadOnInit: true
        },
        SiteContext: Object.assign(siteContextConfig.defaultConfigurations, {
            loadOnInit: true
        })
    },
    experimentalConfigOptions: {
        dm_enforceStrictValidationEverywhere: {
            configOptions: {
                enforceStrictValidationEverywhere: true
            }
        },
        dm_enforceNoWhitelistDalStrictSchemaValidation: {
            configOptions: {
                enforceNoWhitelistDalStrictSchemaValidation: true
            }
        },
        dm_disableSaveInTransaction: {
            configOptions: {
                disableSaveInTransaction: true
            }
        },
        dm_strictBlacklistBaselineForEmployees: {
            configOptions: {
                strictBlacklistBaselineForEmployees: true
            }
        },
        dm_cachePublishedSiteEditor3: {
            configOptions: {
                cachePublishedSite: true
            }
        }
    }
}

export default config as unknown as DSConfig
